<template>
  <div ref="blockRef" class="mx-auto px-4 max-w-6xl">
    <div
      v-if="block.statistics?.length"
      class="grid grid-cols-2 items-center gap-4 md:grid-cols-4"
    >
      <div
        v-for="statistic in block.statistics"
        :key="statistic.id"
        class="flex flex-col items-center justify-center text-center text-purple-dark"
      >
        <div
          v-if="statistic.statistic_value"
          class="flex text-4xl font-black lg:text-6xl"
        >
          {{ statistic.statistic_prepend }}

          <span data-gsap-target="number">
            {{ statistic.statistic_value }}
          </span>

          {{ statistic.statistic_append }}
        </div>

        <div
          v-if="statistic.statistic_text"
          class="mt-2 text-xl font-medium font-serif lg:mt-6 lg:text-2xl"
          data-gsap-target="text"
        >
          {{ statistic.statistic_text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Statistics } from '~/statamic/types/block';

defineProps<{
  block: Statistics;
}>();

let ctx: gsap.Context | null;
const blockRef = ref();

onMounted(() => {
  ctx = useGsap.context((self) => {
    if (typeof self.selector !== 'function') return;

    const numbers = self.selector('[data-gsap-target="number"]');
    const text = self.selector('[data-gsap-target="text"]');

    const timeline = useGsap.timeline({
      scrollTrigger: {
        start: 'top-=50% bottom',
        trigger: blockRef.value,
      },
    });

    if (numbers?.length) {
      timeline.from(numbers, {
        snap: { textContent: 1 },
        stagger: 1.0,
        duration: 2,
        autoAlpha: 0,
        textContent: 0,
      }, '0');
    }

    if (text) {
      timeline.from(text, {
        y: 10,
        scale: 0.5,
        stagger: 1.0,
        autoAlpha: 0,
      }, '0');
    }
  }, blockRef.value);
});

onUnmounted(() => {
  ctx?.revert();
});
</script>
